import React, { Component } from "react";
import classnames from "classnames";
import _ from "i18n";
import { NavLink } from "react-router-dom";
import { SettingIcon } from "../Common/Icons";

export default class SettingsLink extends Component {
  render() {
    return (
      <div className={"settings-menu"} style={{ width: "188px" }}>
        <div className={"settings-menu-drop-down"}>
          <li>
            <SettingIcon fill="#C7E8FE" size={18} />
            <span>{_("settings")}</span>
          </li>
          <i className={classnames("icon icon-arrow-down")} />
        </div>

        <div className={"settings-list"}>
          <NavLink to={"/category-settings"}>{_("categorySettings")}</NavLink>

          <NavLink to={"/task-types"}>{_("taskTypesSettings")}</NavLink>

          <NavLink to={"/collaborators-settings"}>
            {_("collaboratorsSettings")}
          </NavLink>

          <NavLink to={"/calendar-settings"}>{_("calendarSettings")}</NavLink>

          <NavLink to={"/parameter-settings"}>{_("parameterSettings")}</NavLink>

          <NavLink to={"/authorizations"}>{_("users")}</NavLink>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SubMenu/SettingsLink.js